import React from 'react';
import { NavLink } from 'react-router-dom';
import { FiHome, FiBook, FiFileText, FiClock, FiUser } from 'react-icons/fi';
import { useAuth } from '../context/AuthContext';

const MobileBottomNav = () => {
  const { user } = useAuth();

  const navItems = [
    { to: '/dashboard', icon: FiHome, label: 'Home' },
    { to: '/courses', icon: FiBook, label: 'Testseries' },
    { to: '/my-courses', icon: FiFileText, label: 'My Test' },
    { to: '/history', icon: FiClock, label: 'History' },
    { to: '/profile', icon: FiUser, label: 'Profile' },
  ];

  return (
    <>
      {/* Bottom Navigation - Only visible on mobile */}
      <nav className="md:hidden fixed bottom-0 left-0 right-0 bg-white border-t border-gray-200 z-50 safe-area-bottom">
        <div className="flex items-center justify-around h-16">
          {navItems.map((item, index) => {
            const Icon = item.icon;

            return (
              <NavLink
                key={index}
                to={item.to}
                className={({ isActive }) =>
                  `flex flex-col items-center justify-center flex-1 h-full transition-colors active:scale-95 transform ${
                    isActive
                      ? 'text-blue-600'
                      : 'text-gray-600 hover:text-blue-600'
                  }`
                }
              >
                {({ isActive }) => (
                  <>
                    <Icon className="w-6 h-6" />
                    <span className="text-xs mt-1">{item.label}</span>
                    {isActive && (
                      <div className="absolute bottom-0 w-12 h-1 bg-blue-600 rounded-t-full"></div>
                    )}
                  </>
                )}
              </NavLink>
            );
          })}
        </div>
      </nav>

      {/* Spacer to prevent content from being hidden behind bottom nav */}
      <div className="md:hidden h-16"></div>
    </>
  );
};

export default MobileBottomNav;
